import React, { useEffect, useId, useRef, useState } from 'react';
import { Dismiss16Regular } from '@fluentui/react-icons';
import styles from './css/index.module.css';
import { RACI_INFO_INTRO, RACI_ROLE_DEFINITIONS } from './raciConstants';

const RaciLegendPopover = () => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);
    const panelId = useId();
    const titleId = `${panelId}-title`;

    useEffect(() => {
        if (!open) {
            return undefined;
        }
        const onKeyDown = event => {
            if (event.key === 'Escape') {
                setOpen(false);
            }
        };
        const onPointerDown = event => {
            if (rootRef.current && !rootRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('keydown', onKeyDown);
        document.addEventListener('pointerdown', onPointerDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
            document.removeEventListener('pointerdown', onPointerDown);
        };
    }, [open]);

    return (
        <div className={styles.legendPopoverRoot} ref={rootRef}>
            <button
                type="button"
                className={styles.infoButton}
                aria-label="What is a RACI chart?"
                aria-expanded={open}
                aria-controls={open ? panelId : undefined}
                onClick={() => setOpen(prev => !prev)}>
                i
            </button>
            {open && (
                <div
                    id={panelId}
                    className={styles.legendSurface}
                    role="dialog"
                    aria-labelledby={titleId}>
                    <div className={styles.legendHeader}>
                        <h2 id={titleId} className={styles.legendTitle}>
                            What is a RACI chart?
                        </h2>
                        <button type="button" className={styles.legendClose} aria-label="Close" onClick={() => setOpen(false)}>
                            <Dismiss16Regular />
                        </button>
                    </div>
                    <p className={styles.legendIntro}>{RACI_INFO_INTRO}</p>
                    <ul className={styles.legendRoleList}>
                        {RACI_ROLE_DEFINITIONS.map(item => (
                            <li key={item.term} className={styles.legendRoleItem}>
                                <strong className={styles.legendRoleTerm}>{item.term}:</strong> {item.description}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default RaciLegendPopover;
